import axios from 'axios';

const instance = axios.create({
    baseURL: 'https://burger-cave-526fa-default-rtdb.firebaseio.com/'
});

export default instance;


// WEBPACK FOOTER //
// ./src/axios-orders.js